module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.title) ? _c('h3', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.notification) ? _c('div', {
    staticClass: "notification mb-3",
    class: _vm.notification.type
  }, [_vm._v(_vm._s(_vm.notification.message))]) : _vm._e(), _c('ul', {
    staticClass: "status-list"
  }, _vm._l((_vm.steps), function(step, key) {
    return _c('li', [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(key + 1) + ". " + _vm._s(step.name))]), (step.status === _vm.stepStatus.completed) ? _c('b-progress', {
      attrs: {
        "variant": "custom"
      }
    }, [_c('b-progress-bar', {
      staticClass: "completed",
      attrs: {
        "value": 100,
        "max": 100
      }
    }, [(_vm.showDates) ? [(step.code === 'ONL') ? [(_vm.campaign.start_date) ? _c('span', [_vm._v(_vm._s(_vm.$t('fn.date', {
      timestamp: _vm.campaign.start_date
    })))]) : _vm._e()] : (step.code === 'FIN') ? [(_vm.campaign.end_date) ? _c('span', [_vm._v(_vm._s(_vm.$t('fn.date', {
      timestamp: _vm.campaign.end_date
    })))]) : _vm._e()] : (step.slug === 'APPROVED') ? _c('span', [_vm._v(_vm._s(_vm.$t('fn.date', {
      timestamp: step.startedAt
    })))]) : (step.code === 'WRK') ? _c('span', [_vm._v(_vm._s(_vm.$t('terms.misc.see-creative-details')))]) : (step.startedAt && step.finishedAt) ? _c('span', [_vm._v(_vm._s(_vm.$t('fn.date', {
      timestamp: step.startedAt
    })) + " - " + _vm._s(_vm.$t('fn.date', {
      timestamp: step.finishedAt
    })))]) : _vm._e()] : [_c('span', [_vm._v(_vm._s(_vm.$t('terms.misc.completed')))])], _c('icon', {
      attrs: {
        "name": "check",
        "scale": "0.8"
      }
    })], 2)], 1) : _vm._e(), (step.status === _vm.stepStatus.in_progress) ? _c('b-progress', {
      attrs: {
        "variant": "custom"
      }
    }, [(_vm.isCampaignWorkflowView) ? [(step.code !== 'WRK') ? [_c('b-progress-bar', {
      staticClass: "in-progress",
      attrs: {
        "value": 10,
        "max": 100
      }
    }, [(step.info) ? _c('span', {
      staticClass: "progress-info"
    }, [_vm._v(_vm._s(step.info))]) : _vm._e()])] : [_c('b-progress-bar', {
      staticClass: "in-progress",
      attrs: {
        "value": _vm.getCampaignProductionProgress,
        "max": 100
      }
    }, [(step.info) ? _c('span', {
      staticClass: "progress-info"
    }, [_vm._v(_vm._s(step.info))]) : _vm._e()])]] : [_c('b-progress-bar', {
      staticClass: "in-progress",
      attrs: {
        "value": 40,
        "max": 100
      }
    }, [(step.info) ? _c('span', {
      staticClass: "progress-info"
    }, [_vm._v(_vm._s(step.info))]) : _vm._e()])]], 2) : _vm._e(), (step.status === _vm.stepStatus.waiting) ? _c('b-progress', {
      attrs: {
        "variant": "custom"
      }
    }, [_c('b-progress-bar', {
      attrs: {
        "value": 0,
        "max": 100
      }
    }, [(step.info) ? _c('span', {
      staticClass: "progress-info"
    }, [_vm._v(_vm._s(step.info))]) : _vm._e()])], 1) : _vm._e()], 1)
  })), (_vm.canMoveCampaign) ? _c('gotu-nav-button', {
    staticClass: "btn-block mb-2",
    attrs: {
      "theme": "default-cta",
      "className": "btn-block"
    },
    on: {
      "click": _vm.forceMoveCampaign
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.move-campaign')))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41aeb422"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/workflow-progress/WorkflowProgress.vue
// module id = 2034
// module chunks = 1